<template>
  <footer>
    <div class="top-wrap">
      <div class="content">
        <div class="logo hand"></div>
        <div class="line"></div>
        <!-- <div class="link-wrap">
          <a>关于有看投</a>
          <a href="https://www.yicai.com/others/aboutus.html">关于第一财经</a>
          <a @click="linkUrl()">意见反馈</a>
        </div> -->
        <div class="contact-wrap">
          <div>客服热线：400-602-1010</div>
          <div>客服邮箱：ykt@yicai.com</div>
          <div>友情链接︰益盟股份</div>
          <div>工具下载：<a href="https://moss.emoney.cn/download/youkantou/obs-063003.rar">直播客户端下载</a></div>
        </div>
        <div class="images-wrap">
          <div class="app"></div>
          <div class="jg"></div>
        </div>
      </div>
    </div>
    <div class="bottom-wrap">
      <div class="content">
        <div class="copyright">
          <a style="color:#858585" href="https://beian.miit.gov.cn">沪ICP备11023243号-21</a> 沪公网安备31010602007780号 Copyright
          2024.All rights
          reserverd.版权所有第一财经传媒有限公司
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
// import appInfo from '@/assets/js/appInfo.js'
export default {
  name: 'AuthorBottomFooter',
  components: {},
  data() {
    return {}
  },
  created() { },
  methods: {
    linkUrl() {
      this.$router.push('/mine/feedback')
    },
    changeActiveTabsIndex(index) {
      switch (index) {
        case 0:
          this.$router.push('/')
          break
        case 1:
          break
        case 2:
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/style/variable/index.scss';

footer {
  background-color: #f0f0f0;
  z-index: 100;
}

.top-wrap {
  color: #262626;
  font-size: 14px;
  height: 180px;

  .content {
    border-bottom: 1px solid #e0e0e0;
  }

  .line {
    width: 1px;
    height: 40px;
    background-color: #e0e0e0;
    margin: 0 32px 0 38px;
  }

  .link-wrap,
  .contact-wrap {
    display: flex;
    flex-direction: column;
    height: 80px;
    justify-content: space-between;

    a {
      text-decoration: none;
      color: #262626;
    }
  }

  .contact-wrap {
    // margin: 0 236px 0 172px;
    width: 699px;
  }

  .images-wrap {
    display: flex;
    align-items: center;

    .app {
      width: 100px;
      height: 100px;
      background: url('./images/app_icon.png') no-repeat;
      background-size: cover;
    }

    .jg {
      width: 100px;
      height: 100px;
      background: url('./images/jg_icon.png') no-repeat;
      background-size: cover;
      margin: 0 10px 0 40px;
    }
  }

  .logo {
    width: 162px;
    height: 60px;
    background: url('./images/logo.png') no-repeat;
    background-size: cover;
  }
}

.copyright {
  width: 100%;
  font-size: 14px;
  color: #858585;
  line-height: 80px;
  text-align: center;
}

.content {
  width: $page-width;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

a,
.hand {
  cursor: pointer;
}
</style>
